import { StaticRequestPaginateService } from './static-request-paginate.service';

export default angular
  .module('sfMobile.services.static-requests-paginate', [])
  .factory('StaticRequestsPaginate', StaticRequestPaginateService).name;
